<template>
  <div>
    <b-img class="loader" v-show="loading" src="/images/LoaderFF.gif" />
    <div v-show="!loading">
      <dx-pivot-grid
        ref="grid"
        :data-source="pivotGridDataSource"
        :allow-sorting-by-summary="true"
        :allow-sorting="true"
        :allow-filtering="true"
        :show-borders="true"
        :show-column-grand-totals="true"
        :show-row-grand-totals="true"
        :show-row-totals="true"
        :show-column-totals="true"
        width="auto"
        @content-ready="contentReady"
        :on-context-menu-preparing="onContextMenuPreparing"
      >
        <dx-field-chooser :enabled="true" :title="fieldChooserTitle" :show-filter-fields="true" />
        <dx-field-panel
          :showDataFields="true"
          :showRowFields="true"
          :showColumnFields="true"
          :showFilterFields="true"
          :allowFieldDragging="true"
          :visible="getVisible"
        ></dx-field-panel>
      </dx-pivot-grid>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import datalocale from "../locale/pivotlocales";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import ArrayStore from "devextreme/data/array_store";
import { locale, loadMessages } from "devextreme/localization";
import {
  DxPivotGrid,
  DxFieldChooser,
  DxFieldPanel
} from "devextreme-vue/pivot-grid";

export default {
  components: {
    DxPivotGrid,
    DxFieldChooser,
    DxFieldPanel
  },
  props: {
    fieldChooserTitle: {
      type: String,
      required: false,
      default: "Veld configuratie"
    }
  },
  data() {
    return {
      arrayStore: null,
      pivotGridDataSource: null,
      isPageLoaded: false,
      summaryDisplayModes: [
        { text: this.$i18n.t("gridcount"), value: 'none' },
        { text: this.$i18n.t("percentageColumnTotal"), value: 'percentOfColumnTotal' },
        { text: this.$i18n.t("percentageRowTotal"), value: 'percentOfRowTotal' },
        { text: this.$i18n.t("percentagegrandTotal"), value: 'percentOfGrandTotal' },
      ]
    };
  },

  beforeDestroy() {
    if (!!this.pivotGridDataSource && !!this.pivotGridDataSource.dispose) {
      //opruimen!!
      this.pivotGridDataSource.dispose();
      this.pivotGridDataSource = null;
    }
  },

  computed: {
    pivotGrid() {
      return this.$refs.grid;
    },

    loading() {
      return !this.pivotGridDataSource;
    },

    getVisible() {
      if (this.$i18n.locale === "nl") {
        loadMessages(datalocale);
      }
      locale(this.$i18n.locale);

      if (this.isPageLoaded) {
        // De dx-pivot-grid moet helaas herladen worden nadat de locale is gewijzigd, zie voorbeeld pagina:
        // https://js.devexpress.com/Demos/WidgetsGallery/Demo/Localization/UsingGlobalize/Vue/Light/
        // welke een "document.location.reload();" doet (dus een gehele pagina reload).
        // Volgens https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxPivotGrid/Methods/#repaint
        // zou er een repaint() method beschikbaar moeten zijn om alleen de grid dynamisch te repainten zonder de data
        // opnieuw op te halen. Echter, wanneer deze method wordt aangeroepen (this.$refs.grid.repaint()), krijg
        // je de foutmelding dat repaint geen function is.
        // Ook alternatief "invalidate()" (volgens ticket T651448) werkt niet.
        // Voor nu met Michel afgestemd dat de gehele pagina wordt verversd.

        document.location.reload();
      } else {
        this.isPageLoaded = true;
      }

      return true;
    }
  },

  methods: {
    onContextMenuPreparing(e) {
      if (e.field && e.field.summaryType === 'count') {
        this.summaryDisplayModes.forEach((mode) => {
          e.items.push({
            text: mode.text,
            selected: e.field.summaryDisplayMode === mode.value,
            onItemClick: () => {
              let format;
              const caption = mode.value === 'none' ? this.$i18n.t("gridcount") : this.$i18n.t("relative");
              if (mode.value === 'none'
                  || mode.value === 'absoluteVariation') {
                format = '';
              }
              this.pivotGridDataSource.field(e.field.index, {
                summaryDisplayMode: mode.value,
                format,
                caption,
              });

              this.pivotGridDataSource.load();
            },
          });
        });
      }
    },


    bindChart: function(chart, inverted) {
      inverted = !!inverted; //default false
      const pivotGrid = this.$refs.grid.instance;

      pivotGrid.bindChart(chart, {
        dataFieldsDisplayMode: "splitPanes",
        alternateDataFields: true,
        inverted: inverted
      });
    },

    fillGrid(fields, store) {
      this.arrayStore = new ArrayStore(store);

      if (!!this.pivotGridDataSource && !!this.pivotGridDataSource.dispose) {
        //opruimen!!
        this.pivotGridDataSource.dispose();
        this.pivotGridDataSource = null;
      }

      this.pivotGridDataSource = new PivotGridDataSource({
        fields: fields,
        store: this.arrayStore
      });
    },

    getFields() {
      let pivotGridFields = this.pivotGridDataSource.fields();
      return pivotGridFields;
    },

    setFields(dataFields) {
      this.pivotGridDataSource.fields(dataFields);
      //refresh de UI:
      this.pivotGridDataSource.load();
    },

    contentReady() {
      this.$emit("grid-fields-changed");
    },

    fieldsLoaded() {
      return !!this.pivotGridDataSource && !!this.pivotGridDataSource.fields;
    }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  display: block;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}
</style>

